import React, { useCallback } from 'react';
import { GridContainer, Grid } from '../../../shared/grid';
import 'src/features/field-sample/FieldSample.scss';
import Button from '@mui/material/Button';
import { alertMessages } from 'src/constants';
import { useStoreContext } from 'src/store/context';
import { useAddAlert } from 'src/store/actions';
import { deleteFuelCatalog } from 'src/apis/mutationCatalogs';
import { errorResponse } from 'src/store/common';

type DeleteFuelCatalogProps = {
    setOpenDeleteModal: any,
    setDeleteFuelCatalogSuccess: any,
    deleteCatalogId: any,
    catalogName: any,
    catalogCategory: any
}

export const DeleteCatalog: React.FC<DeleteFuelCatalogProps> = ({ setOpenDeleteModal, setDeleteFuelCatalogSuccess, deleteCatalogId, catalogName, catalogCategory }) => {
    const [, dispatch] = useStoreContext();
    const addAlert = useAddAlert(dispatch);

    const deleteFuelCatalogById = useCallback((id) => {
        (async() => {
            try {
                const request = {
                    id: id
                };
                const response: any = await deleteFuelCatalog(request, catalogCategory, addAlert);
                if(response){
                    errorResponse('', addAlert, `${catalogName} was successfully deleted.`, true);
                    setDeleteFuelCatalogSuccess(true);
                    setOpenDeleteModal(false);
                }
            } catch (error) {
                addAlert({
                    id: '',
                    message: alertMessages.fuelCatalogDelete,
                    type: 'error-info',
                    icon: 'fa-exclamation-triangle'
                })
            }
        })();
    }, [addAlert, setOpenDeleteModal, setDeleteFuelCatalogSuccess, catalogCategory, catalogName]);
    
    const handleDeleteButton = () => { 
        deleteFuelCatalogById(deleteCatalogId);   
    }

    const handleCancelButton = ()=>{
        setOpenDeleteModal(false);
    }

    return (
        <GridContainer className="removePadding">
            <Grid row gap="md" className='page-heading'>
                <Grid
                    desktop={{ col: 12 }}
                    className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 paddingForModal">
                    <span className="font-sans-lg text-bold">Delete Catalog</span>
                </Grid>
            </Grid>
            <hr style={{ width: '100%', marginBottom: 0 }}></hr>
            <Grid row className="paddingForm2">
                { catalogCategory === "Parent" ?
                    <span>Catalog <strong style={{textTransform:'capitalize'}}><em>{catalogName}</em></strong> will be deleted. Any stations assigned to this catalog will be reassigned to the <strong><em>National Catalog</em></strong>. Do you want to continue?</span>
                    :
                    <span>Catalog <strong style={{textTransform:'capitalize'}}><em>{catalogName}</em></strong> will be deleted. Do you want to continue?</span>
                }
            </Grid>

            <Grid row className='modalBottomDiv'>
                <Grid desktop={{ col: 9 }} className="modalCancelDiv">
                    <Button variant="outlined" style={{ backgroundColor: 'white',textTransform: 'none' }} onClick={() => { handleCancelButton()}}>
                        Cancel
                    </Button>
                </Grid>
                <Grid desktop={{ col: 3 }} className='modalSubmitDiv'>
                    <Button color="error" variant="contained" type="submit" style={{textTransform: 'none'}} onClick={() => { handleDeleteButton() }}>
                        Confirm
                    </Button>
                </Grid>
            </Grid>
        </GridContainer>
    )
}